document.addEventListener('DOMContentLoaded', function() {
  const initFaqAccordions = () => {
    const faqSections = document.querySelectorAll('.section-faq');
    faqSections.forEach(section => {
      const items = section.querySelectorAll('.faq__accordion-item');
      items.forEach(item => {
        const btn = item.querySelector('.faq__question-btn');
        if (!btn || btn.hasAttribute('data-faq-bound')) return;
        btn.setAttribute('data-faq-bound', 'true');

        btn.addEventListener('click', function() {
          const isOpen = item.classList.contains('is-open');
          
          items.forEach(i => {
            i.classList.remove('is-open');
            const b = i.querySelector('.faq__question-btn');
            if (b) b.setAttribute('aria-expanded', 'false');
          });

          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  };

  initFaqAccordions();
  document.addEventListener('shopify:section:load', initFaqAccordions);
});
